import React from 'react';
import { useTranslation } from 'react-i18next';

const Imprint = () => {

  const { t } = useTranslation();
  
  return (
    <div className="text-center py-10">
      <h1 className="text-3xl font-bold">{t('imprint')}</h1>
      <div className="pt-10">
        <p>Moritz Pflüger</p>
        <a href="mailto:hello@moritzpflueger.com" className="underline">hello@moritzpflueger.com</a> <br />
      </div>
      <address className="pt-10">
        Am Stutenanger 11A <br />
        85764 Oberschleißheim <br />
        GERMANY
      </address>
    </div>
  );
};

export default Imprint;
